module.exports = __webpack_public_path__ + "static/img/page7_img1.1ed753c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img1.jpg
// module id = 7OVL
// module chunks = 1